import { render, staticRenderFns } from "./CreateConsultant.vue?vue&type=template&id=60036382&scoped=true"
import script from "./CreateConsultant.vue?vue&type=script&lang=js"
export * from "./CreateConsultant.vue?vue&type=script&lang=js"
import style0 from "./CreateConsultant.vue?vue&type=style&index=0&id=60036382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60036382",
  null
  
)

export default component.exports